import React, { useState, useRef, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  message,
  Checkbox,
  Switch,
  Upload,
  Radio,
} from "antd";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import Button from "atoms/Button";
import { CALL_API, CALL_API_EMAIL } from "common/API";
import moment from "moment";
import {
  NON_EMPTY_REGEX,
  EMAIL_REGEX,
  STATUS_CODE,
  countryList,
  TIMEZONELIST,
  AwardList,
  CountryData,
  VALIDATE_CHARACTER,
} from "common/Constants";
import SelectTable from "../molecules/SelectTable";
import InReview from "../organisms/FormReview";
import { bindActionCreators } from "redux";
import {
  getAllDepartmentList,
  getLocations,
  getClientid,
  getLeaveCategoryList,
  getRoleList,
  getUserList,
  getBandList,
  getUserMenuList,
  getProductInfo,
  getUserInfo,
} from "redux/selectors";
import { setRoleList, setUserList } from "redux/actions";
import { chain, get, includes, isEmpty } from "lodash";
import { useDropzone } from "react-dropzone";
import StepsProgress from "./StepsProgress";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FormModal from "./FormModal";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { CloseOutlined } from "@mui/icons-material";
import RolesAndPermissions from "pages/RolesAndPermissions";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const StyledModal = styled(Form)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: 600;
    text-align: center;
    font-size: 24px;
    color: #1b1b1b;
  }
  .anticon {
    color: #000000;
    width: 14px;
    height: 14px;
  }
  .ant-modal-close {
    margin-top: 14px;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
  .ant-btn-text:focus,
  .ant-btn-text:hover {
    background: #26a4ff;
    color: #ffffff;
  }
  .check-box {
    font-size: 14px;
    font-weight: 500;
  }
  .add_employee_col {
    padding: 5px;
  }
  .review_data_box_container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: wrap;
  }
  .review_data_box {
    width: auto;
    padding: 1rem 1.4rem;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000015;
  }
  .review_datas {
    display: flex;
    justify-content: space-between;
    text-align: left;
    gap: 1rem;
  }
  .review_datas_key {
    text-align: left;
    font: normal normal bold 16px/20px Circular Std;
    letter-spacing: 0px;
    color: #000000;
  }
  .review_datas_value {
    text-align: left;
    font: normal normal normal 16px/20px Circular Std;
    letter-spacing: 0px;
    color: #000000;
  }
  .review_title {
    border-bottom: 1.5px solid #d9d9d9;
    width: fit-content;
    text-align: left;
    font: normal normal Bold 18px/20px Circular Std;
    letter-spacing: 0px;
    color: #000000;
  }
`;

const StyleRow = styled(Row)`
  .ant-form-item-label {
    text-align: left;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background: #f2f2f2;
    }
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      position: relative;
      height: 40px !important;
      padding: 8px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      color: #397ff4;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }
`;

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
`;

const StyledDropzone = styled.div`
  text-align: center;
  width: 100%;
  height: 40px;
  background: #e3e3e3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  p {
    padding-top: 10px;
  }
`;

function AddEmployee({
  closeModal,
  getEmployeeList,
  EmployeeList,
  ClientId,
  updateUserList,
  roleList,
  bandList,
  locationList,
  allDepartmentList,
  userMenuList,
  clientId,
  saveRoleList,
  productInfo,
  userList,
  userInfo,
  selectedDetails = {},
  leaveCategoryList,
}) {
  console.log("leaveCategoryList", leaveCategoryList);
  const { t } = useTranslation();

  const [showLoader, toggleLoader] = useState(false);
  const [filename, setFileName] = useState("");
  const [form] = Form.useForm();
  const { Option } = Select;
  const containerRef = useRef(null);
  const [profileUploaded, setProfileUploaded] = useState(false);
  const [uniqueId, setUniqueId] = useState(generateUniqueId());
  const [storeId, setStoreId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState([]);
  const [baseLocation, setBaseLocation] = useState("");
  const [baseDepartment, setBaseDepartment] = useState("");
  const [selectAllRoleChecked, setSelectAllRoleChecked] = useState(false);
  const [menuList, setMenuList] = useState(userMenuList);

  useEffect(() => {
    const {
      userid = "",
      startdate = "",
      dateofbirth = "",
      enddate = "",
      bandname = "",
      bandid = "",
      overtimestatus = "",
      salary = "",
      password = "",
      profileurl = "",
      gender = "",
      maritalstatus = "",
      nationality = "",
      roleid = "",
      nssf = "",
      national_id = "",
      krapin = "",
      sharegnum = "",
      driverslicense = "",
      contract = "",
      address = "",
      phoneno = "",
      companyname = "",
      jobtitle = "",
      professionalsince = "",
      hireddate = "",
      probationstartdate = "",
      probationenddate = "",
      contractstartdate = "",
      contractenddate = "",
      relevant = "",
      employeesponser = "",
      statusname = "",
      jobdescription = "",
      emergencycontactname = "",
      emergencycontactnumber = "",
      employementtype = "",
      employeeid = "",
      initial,
      firstname,
      lastname,
      salutation,
      educationdetails,
      workexperience,
      professionalcertifications,
      practicaltrainings,
      lastpromotionlevel,
      lastpromotiondate,
      reportingmanager,
    } = selectedDetails;

    setFormValues({
      user_id: userid,
      gender: gender,
      date_of_birth: dateofbirth ? moment(dateofbirth, "YYYY-MM-DD") : null,
      password: password,
      marital_status: maritalstatus,
      nationality: nationality,
      start_date: startdate ? moment(startdate, "YYYY-MM-DD") : null,
      end_date: enddate ? moment(enddate) : "",
      bandName: bandname,
      bandid: bandid,
      overtime: overtimestatus,
      salary: salary,
      employementtype: employementtype,
      profile_url: profileurl !== ("" || null || undefined) ? profileurl : null,
      role_id: roleid,
      nssf: nssf,
      national_id: national_id,
      krapin: krapin,
      sharegnum: sharegnum,
      driverslicense: driverslicense,
      contract: contract,
      address: address,
      phone: phoneno,
      companyname: companyname,
      jobtitle: jobtitle,
      professionalsince: professionalsince
        ? moment(professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      probationstartdate: probationstartdate
        ? moment(probationstartdate, "YYYY-MM-DD")
        : null,
      probationenddate: probationenddate
        ? moment(probationenddate, "YYYY-MM-DD")
        : null,
      contractstartdate: contractstartdate
        ? moment(contractstartdate, "YYYY-MM-DD")
        : null,
      contractenddate: contractenddate
        ? moment(contractenddate, "YYYY-MM-DD")
        : null,
      relevent: relevant,
      employeesponser: employeesponser,
      employeestatus: statusname,
      status_id: employeeStatusId,
      description: jobdescription,
      emergencycontactname: emergencycontactname,
      emergencycontactnumber: emergencycontactnumber,
      employeeid: employeeid,
      initial: initial,
      firstname: firstname,
      lastname: lastname,
      salutation: salutation,
      lastpromotionlevel: lastpromotionlevel,
      reportingmanager: reportingmanager,
      lastpromotiondate: lastpromotiondate
        ? moment(startdate, "YYYY-MM-DD")
        : null,
      educationdetails:
        educationdetails?.length !== 0
          ? educationdetails
          : [
              {
                institutename: "",
                fromdate: "",
                todate: "",
                exambody: "",
                awarded: "",
              },
            ],
      workexperience:
        workexperience?.length !== 0
          ? workexperience
          : [
              {
                companyname: "",
                fromdate: "",
                todate: "",
                jobtitle: "",
                relevnt: "",
                jobdescription: "",
              },
            ],
      professionalcertifications:
        professionalcertifications?.length !== 0
          ? professionalcertifications
          : [{ certificationtype: "", fromdate: "", todate: "", remarks: "" }],
      practicaltrainings:
        practicaltrainings?.length !== 0
          ? practicaltrainings
          : [
              {
                organisationname: "",
                fromdate: "",
                todate: "",
                positionheld: "",
                tasksperformed: "",
              },
            ],
    });

    const transformedDetails = (data) =>
      data?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const isValidFromDate = !isNaN(Date.parse(fromdate));
        const isValidToDate = !isNaN(Date.parse(todate));
        return {
          ...rest,
          fromdate: isValidFromDate ? moment(fromdate) : null,
          todate: isValidToDate ? moment(todate) : null,
        };
      });

    form.setFieldsValue({
      user_id: userid,
      password: password,
      gender: gender,
      date_of_birth: dateofbirth ? moment(dateofbirth, "YYYY-MM-DD") : null,
      marital_status: maritalstatus,
      nationality: nationality,
      start_date: startdate ? moment(startdate, "YYYY-MM-DD") : null,
      end_date: enddate ? moment(enddate) : "",
      bandid: bandid,
      overtime: overtimestatus,
      salary: salary,
      profile_url: profileurl != ("" || null || undefined) ? profileurl : null,
      role_id: roleid,
      nssf: nssf,
      national_id: national_id,
      krapin: krapin,
      sharegnum: sharegnum,
      driverslicense: driverslicense,
      contract: contract,
      address: address,
      employementtype: employementtype,
      phone: phoneno,
      companyname: companyname,
      jobtitle: jobtitle,
      professionalsince: professionalsince
        ? moment(professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      probationstartdate: probationstartdate
        ? moment(probationstartdate, "YYYY-MM-DD")
        : null,
      probationenddate: probationenddate
        ? moment(probationenddate, "YYYY-MM-DD")
        : null,
      contractstartdate: contractstartdate
        ? moment(contractstartdate, "YYYY-MM-DD")
        : null,
      contractenddate: contractenddate
        ? moment(contractenddate, "YYYY-MM-DD")
        : null,
      relevent: relevant,
      employeesponser: employeesponser,
      employeestatus: statusname,
      description: jobdescription,
      emergencycontactnumber: emergencycontactnumber,
      emergencycontactname: emergencycontactname,
      employeeid: employeeid,
      initial: initial,
      firstname: firstname,
      lastname: lastname,
      salutation: salutation,
      lastpromotionlevel: lastpromotionlevel,
      lastpromotiondate: lastpromotiondate
        ? moment(startdate, "YYYY-MM-DD")
        : null,
      reportingmanager: reportingmanager,
      educationdetails: educationdetails
        ? transformedDetails(educationdetails)
        : [
            {
              institutename: "",
              fromdate: "",
              todate: "",
              exambody: "",
              awarded: "",
            },
          ],
      workexperience: workexperience
        ? transformedDetails(workexperience)
        : [
            {
              companyname: "",
              fromdate: "",
              todate: "",
              jobtitle: "",
              relevnt: "",
              jobdescription: "",
            },
          ],
      professionalcertifications: professionalcertifications
        ? transformedDetails(professionalcertifications)
        : [{ certificationtype: "", fromdate: "", todate: "", remarks: "" }],
      practicaltrainings: practicaltrainings
        ? transformedDetails(practicaltrainings)
        : [
            {
              organisationname: "",
              fromdate: "",
              todate: "",
              positionheld: "",
              tasksperformed: "",
            },
          ],
    });
  }, []);

  const jwtToken = window.localStorage.getItem("token");

  const getCountryCodeByName = (countryName) => {
    const country = CountryData.find(
      (country) => country.name.toLowerCase() === countryName.toLowerCase()
    );
    return country ? country.code : null;
  };

  const getMaxLengthByCountry = (countryName) => {
    const country = CountryData.find(
      (country) => country.name.toLowerCase() === countryName.toLowerCase()
    );
    return country ? country.phone_length : null;
  };

  const locationId = chain(roleList)
    .filter((role) => selectedRoleId.includes(role.roleId))
    .flatMap((role) => role.locationId)
    .uniq()
    .value();

  const locationBasedOnRole = locationList?.filter((val) =>
    locationId.includes(val?.location_id)
  );
  const filterLocationList = locationList?.filter(
    (item) => item?.login_from_anywhere !== 1
  );

  const departmentId = chain(roleList)
    .filter((role) => selectedRoleId.includes(role.roleId))
    .flatMap((role) => role.department)
    .uniq()
    .value();

  const departmentBasedOnRole = allDepartmentList?.filter((val) =>
    departmentId.includes(val?.department_id)
  );

  const [employeeStatusId, setEmployeeStatusId] = useState("1");
  const filterDepartment = roleList?.find((item) =>
    form.getFieldValue("role_id")?.includes(item?.roleId)
  )?.department;

  const [emailsList, setEmailList] = useState([]);

  const getEmailList = async () => {
    const { code, response } = await CALL_API_EMAIL(
      `add-users/email-list`,
      "get"
    );
    if (code === STATUS_CODE.SUCCESS) setEmailList(response);
  };

  useEffect(() => {
    setSelectAllRoleChecked(selectedRoleId?.length === roleList?.length);
  }, [selectedRoleId, selectAllRoleChecked, roleList]);

  useEffect(() => {
    setProfileUploaded(false);
    getEmailList();
  }, []);

  const emailList = EmployeeList?.map((user) => user.userid);

  const [step, setStep] = useState(0);
  const [formValues, setFormValues] = useState({});
  const [reviewBasicData, setReviewBasicData] = useState({});
  const [reviewEducationData, setReviewEducationData] = useState({});
  const [reviewWorkData, setReviewWorkData] = useState({});

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      { fetch_master_data }
    );
    if (code === STATUS_CODE.SUCCESS) {
      updateUserList(userList);
      saveRoleList(roleList);
    }
  };

  const validateEmployeeId = (rule, value) => {
    if (value && emailsList.includes(value) && isEmpty(selectedDetails)) {
      return Promise.reject(t("User ID already exist"));
    }
    return Promise.resolve();
  };

  const isKenyaSelected = () => form.getFieldValue("nationality") === "Kenya";
  const isIndiaSelected = () => form.getFieldValue("nationality") === "India";
  const handleCountryChange = () => {
    const country = form.getFieldValue("nationality");
    if (country !== "Kenya") {
      form.setFieldValue("national_id", "");
      form.setFieldValue("nssf", "");
      form.setFieldValue("krapin", "");
    }
    if (country !== "India") {
      form.setFieldValue("aadhaar_id", "");
      form.setFieldValue("pan_number", "");
    }
    onFinish(0);
  };

  const handlesubmit = async (roleId, roleName) => {
    try {
      setUniqueId(generateUniqueId());

      const {
        user_id,
        password,
        gender,
        date_of_birth,
        nationality,
        start_date,
        address,
        phone,
        overtime,
        salary,
        selectedRoleId,
        institute_Name,
        degree,
        specialization,
        company_Name,
        job_Title,
        relevent,
        employee_status,
        marital_status,
        employee_sponser,
        description,
        emergencycontactname,
        emergencycontactnumber,
        employementtype,
        bandid,
        usertimezone,
        salutation,
        initial,
        firstname,
        lastname,
        nssf,
        national_id,
        krapin,
        aadhaar_id,
        pan_number,
        sharegnum,
        driverslicense,
        contract,
        educationdetails,
        professionalcertifications,
        workexperience,
        practicaltrainings,
        probationstartdate,
        probationenddate,
        contractstartdate,
        contractenddate,
        reportingmanager,
        lastpromotionlevel,
        lastpromotiondate,
      } = formValues;

      const roleNames = roleList
        .filter((item) => selectedRoleId?.includes(item.roleId))
        .map((item) => item.roleName);

      let userId = form.getFieldValue("user_id");
      let splitUserId = userId.split("@");
      let userIdWithoutDomain = splitUserId[0];
      let updatedUserId = userIdWithoutDomain + storeId;
      const dobDate = new Date(date_of_birth);
      const currentDate = new Date();
      const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();
      const bandNameList = bandList?.filter((item) => item?.bandId === bandid);

      const workexperienceDetails = workexperience?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        return {
          ...rest,
          fromdate: moment(fromdate).format("YYYY-MM-DD"),
          todate: moment(todate).format("YYYY-MM-DD"),
        };
      });

      const transformedEducationDetails = educationdetails?.map((item) => {
        const { attachment, fromdate, todate, ...rest } = item;
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId,
        }));
        return {
          ...rest,
          fromdate: moment(fromdate).format("YYYY-MM-DD"),
          todate: moment(todate).format("YYYY-MM-DD"),
          attachment: updatedAttachment,
        };
      });

      const practicaltrainingsDetails = practicaltrainings?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        return {
          ...rest,
          fromdate: moment(fromdate).format("YYYY-MM-DD"),
          todate: moment(todate).format("YYYY-MM-DD"),
        };
      });

      const professionalcertificationsDetails = professionalcertifications?.map(
        (item) => {
          const { attachment, fromdate, todate, ...rest } = item;
          const updatedAttachment = attachment?.map((att) => ({
            name: att?.name,
            uniqueId: att?.response?.uniqueId,
          }));
          return {
            ...rest,
            fromdate: moment(fromdate).format("YYYY-MM-DD"),
            todate: moment(todate).format("YYYY-MM-DD"),
            attachment: updatedAttachment,
          };
        }
      );

      const response = await CALL_API(`add-users/${ClientId}`, "post", {
        leaveAccurals:
          form.getFieldValue("leaveAccurals")?.[0]?.leave_category_id !== ""
            ? form.getFieldValue("leaveAccurals")
            : [],
        user_id: user_id?.toLowerCase(),
        full_name: `${firstname} ${lastname}`,
        password,
        start_date: start_date
          ? moment(start_date?._d).format("YYYY-MM-DD")
          : "",
        dateofbirth: date_of_birth
          ? moment(date_of_birth?._d).format("YYYY-MM-DD")
          : "",
        gender,
        age: agecalculte,
        maritalstatus: marital_status,
        nationality,
        role_id: [roleId],
        bandname: bandNameList?.length !== 0 ? bandNameList[0]?.bandName : "",
        bandid,
        employementtype: employementtype ? employementtype : "",
        role_name: [roleName],
        institutename: institute_Name,
        degree,
        specialization,
        yearofcompletion: formValues?.year_of_completion
          ? moment(formValues?.year_of_completion?._d).format("YYYY-MM-DD")
          : "",
        companyname: company_Name,
        jobtitle: job_Title,
        professionalsince: formValues?.professional_since
          ? moment(formValues?.professional_since._d).format("YYYY-MM-DD")
          : "",
        hireddate: formValues?.hired_date
          ? moment(formValues?.hired_date._d).format("YYYY-MM-DD")
          : "",
        relevant: relevent,
        employeesponser: employee_sponser,
        statusname: employee_status,
        jobdescription: description,
        status_id: employeeStatusId,
        staff_department_id:
          filterDepartment && filterDepartment?.length > 0
            ? filterDepartment[0]
            : "",
        overtime_status: overtime,
        salary: salary ? salary : "",
        address,
        phoneno: phone,
        profile_url: profileUploaded
          ? `https://tymeplushr-profile-wailasoft-dev.s3.eu-west-1.amazonaws.com/${ClientId}/${updatedUserId}/${storeId}.jpg`
          : null,
        presentaddress: address,
        permanentaddress: address,
        emergencycontactname,
        emergencycontactnumber,
        baselocationid: baseLocation,
        basedepartmentid: baseDepartment,
        usertimezone,
        salutation,
        initial,
        firstname,
        lastname,
        nssf,
        national_id,
        krapin,
        aadhaar_id,
        pan_number,
        sharegnum,
        driverslicense,
        contract,
        educationdetails: transformedEducationDetails,
        professionalcertifications: professionalcertificationsDetails,
        workexperience: workexperienceDetails,
        practicaltrainings: practicaltrainingsDetails,
        reportingmanager,
        lastpromotionlevel,
        lastpromotiondate: moment(lastpromotiondate).format("DD-MM-YYYY"),
        probationstartdate: probationstartdate
          ? moment(probationstartdate?._d).format("YYYY-MM-DD")
          : "",
        probationenddate: probationenddate
          ? moment(probationenddate?._d).format("YYYY-MM-DD")
          : "",
        contractstartdate: contractstartdate
          ? moment(contractstartdate?._d).format("YYYY-MM-DD")
          : "",
        contractenddate: contractenddate
          ? moment(contractenddate?._d).format("YYYY-MM-DD")
          : "",
        onboardingemployee: isEmpty(selectedDetails) ? "" : "onboarding",
      });

      toggleLoader(false);
      form.resetFields();
      setFileName("");
      closeModal(true);

      if (response.code === "SUCCESS") {
        if (response?.message === "Please Upgrade Your Plan") {
          message.error(response?.message);
        } else {
          message.success(response?.message);
        }
      }
      getEmployeeList();
      fetchMasterData(true);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  function generateUniqueId() {
    const usedIds = [];
    let uniqueId = "";
    while (uniqueId?.length !== 6) {
      const randomNumber = Math.floor(Math.random() * 900000) + 100000;
      if (!usedIds.includes(randomNumber.toString())) {
        usedIds.push(randomNumber.toString());
        uniqueId += randomNumber.toString();
      }
    }
    return uniqueId;
  }

  const Reset = () => {
    form.resetFields();
    setFileName("");
  };

  const onFinish = (step) => {
    const currentFormValues = form.getFieldValue();
    const updatedFormValues = { ...currentFormValues, selectedRoleId };
    setFormValues(updatedFormValues);
    setStep(step);
    if (step === 6) {
      setReviewBasicData({
        initial: formValues?.initial,
        firstname: formValues?.firstname,
        lastname: formValues?.lastname,
        user_id: formValues?.user_id,
        date_of_birth: formValues?.date_of_birth
          ? moment(formValues?.date_of_birth?._d).format("YYYY-MMMM-DD")
          : "",
        password: formValues?.password
          ? "*".repeat(formValues.password?.length - 2) +
            formValues.password.slice(-2)
          : "",
        gender: formValues?.gender,
        phone: formValues?.phone,
        marital_status: formValues?.marital_status,
        nationality: formValues?.nationality,
        address: formValues?.address,
        overtime: formValues?.overtime,
        start_date: formValues?.start_date
          ? moment(formValues?.start_date?._d).format("YYYY-MMMM-DD")
          : "-",
        EmergencyContactName: formValues?.emergencycontactname,
        EmergencyContactNumber: formValues?.emergencycontactnumber,
        employementtype: formValues?.employementtype,
      });
      setReviewEducationData({
        institute_Name: formValues?.institute_Name,
        degree: formValues?.degree,
        specialization: formValues?.specialization,
        year_of_completion: formValues?.year_of_completion
          ? moment(formValues?.year_of_completion?._d).format("YYYY-MMMM-DD")
          : "-",
      });
    }
  };

  useEffect(() => {
    setReviewWorkData({
      company_Name: formValues?.company_Name,
      job_Title: formValues?.job_Title,
      employee_sponser: formValues?.employee_sponser,
      description: formValues?.description,
      relevent: formValues?.relevent,
      professional_since: formValues?.professional_since
        ? moment(formValues?.professional_since?._d).format("YYYY")
        : "",
      hired_date: formValues?.hired_date
        ? moment(formValues?.hired_date?._d).format("YYYY-MMMM-DD")
        : "",
      employee_status: formValues?.employee_status,
    });
  }, [step]);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: async (acceptedFiles) => {
      const userId = form.getFieldValue("user_id");
      if (!userId) {
        message.error(t("Please Enter User ID"));
        return;
      }
      acceptedFiles.forEach(async (file) => {
        const reader = new FileReader();
        reader.onload = async function (e) {
          if (
            includes(
              [
                "image/jpeg",
                "image/jpg",
                "image/jpeg",
                "image/png",
                "image/tif",
                "image/tiff",
                "png",
                "jpg",
                "tif",
              ],
              get(file, "type", "")
            )
          ) {
            setFileName(file.path);
            setProfileUploaded(true);
            setUniqueId(generateUniqueId());
            const splitUserId = userId.split("@");
            const userIdWithoutDomain = splitUserId[0];
            const updatedUserId = userIdWithoutDomain + uniqueId;
            const { code } = await CALL_API(
              `profile-upload/${ClientId}`,
              "post",
              {
                userid: updatedUserId,
                filetype: get(file, "type", ""),
                content: e.target.result,
                filename: uniqueId,
                emailid: "",
              }
            );
            if (code === STATUS_CODE.SUCCESS) {
              setStoreId(uniqueId);
            }
          } else {
            setProfileUploaded(false);
            message.error(t("Please upload a valid image file."));
          }
        };
        reader.readAsDataURL(file);
      });
    },
  });

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const validateEmail = (rule, value) => {
    if (value && emailList.includes(value.trim())) {
      return Promise.reject(t("This Email is already registered"));
    }
    return Promise.resolve();
  };

  const rolecolumns = [
    {
      title: t("Role Name"),
      dataIndex: "roleName",
      key: "roleName",
      width: "10%",
    },
    {
      title: t("Access Level"),
      dataIndex: "roleId",
      key: "roleId",
      width: "10%",
      align: "center",
      render: (roleId) => (
        <Switch
          size="small"
          checked={selectAllRoleChecked || selectedRoleId.includes(roleId)}
          onChange={(checked) => getRoleId(roleId, checked)}
        />
      ),
    },
  ];

  const baseLocationColumn = [
    {
      title: t("Select Base Location"),
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: t("Timezone"),
      dataIndex: "usertimezone",
      key: "usertimezone",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => (
        <Switch
          size="small"
          checked={baseLocation === location_id}
          onChange={(checked) => setBaseLocation(checked ? location_id : "")}
        />
      ),
    },
  ];

  const baseDepartmentColumn = [
    {
      title: t("Select Base Department"),
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => (
        <Switch
          size="small"
          checked={baseDepartment === department_id}
          onChange={(checked) =>
            setBaseDepartment(checked ? department_id : "")
          }
        />
      ),
    },
  ];

  const getRoleId = (role_id, checked) => {
    const newRoleId = checked
      ? [...selectedRoleId, role_id]
      : selectedRoleId.filter((item) => item !== role_id);
    setSelectedRoleId(newRoleId);
  };

  const handleSelectAllRole = (e) => {
    const checked = e.target.checked;
    setSelectAllRoleChecked(checked);
    const allRoleIds = roleList.map((item) => item.roleId);
    setSelectedRoleId(checked ? allRoleIds : []);
  };

  const stepdata = [
    { id: 1, title: t("Basic") },
    { id: 2, title: t("Department") },
    { id: 3, title: t("Location") },
    { id: 4, title: t("Education") },
    { id: 5, title: t("Work") },
    { id: 6, title: t("Leave") },
    { id: 7, title: t("Permission") },
    { id: 8, title: t("Review") },
  ];

  const uploadFile = async (value) => {
    const { file } = value;
    try {
      if (!isEmpty(file)) {
        const { user_id } = formValues;
        await CALL_API(`upload-userdocuments/${ClientId}`, "post", {
          userId: user_id?.toLowerCase(),
          name: file.name,
          type: file.type,
          uniqueId: file.response.uniqueId,
          content: file.response.base64Data,
        });
      }
    } catch (error) {
      console.error("[handlesubmit] error --->", error);
    }
  };

  const handleFileRemove = async (file) => {
    const userId = form.getFieldValue("user_id");
    let splitUserId = userId.split("@");
    let userIdWithoutDomain = splitUserId[0];
    let updatedUserId = userIdWithoutDomain;
    let fileKey = `${updatedUserId}_${file?.response?.uniqueId}_${file?.name
      .split(" ")
      .join("_")}`;
    try {
      await CALL_API(
        `delete-userdocuments?clientid=${ClientId}&filekey=${fileKey}`,
        "delete"
      );
      console.error(
        "[handleFileRemove] success -->",
        "File deleted successfully"
      );
    } catch (error) {
      console.error("[handleFileRemove] error -->", error);
    }
  };

  const handlePermissionSubmit = async () => {
    toggleLoader(true);
    try {
      const response = await CALL_API(`owner-roles/${clientId}`, "post", {
        rolename: `${formValues?.firstname} ${formValues?.lastname}`,
        location: [baseLocation],
        menuList: menuList,
        department: [baseDepartment],
      });
      if (response?.code === STATUS_CODE.SUCCESS) {
        const roleId = response?.roleData?.roleId;
        const roleName = response?.roleData?.roleName;
        handlesubmit(roleId, roleName);
        fetchMasterData(true);
        console.log("API Response:", response);
      } else {
        console.error("Error in API response:", response);
      }
    } catch (error) {
      console.error("Error in handlePermissionSubmit:", error);
    }
  };

  let token = null;
  try {
    if (jwtToken) {
      token = jwtDecode(jwtToken);
    }
  } catch (error) {
    console.error("Invalid token:", error);
  }

  return (
    <>
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => closeModal(false)}
      >
        {t("Employee")} <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <b className="pb-0 pt-1">{t("Add Employee")}</b>
      <StepsProgress stepdata={stepdata} title="" step={step} />
      <div className="styled-card mb-5">
        {step === 0 && (
          <StyledModal>
            <Form
              form={form}
              name="addemployeeform"
              layout="vertical"
              initialValues={{
                initial: "",
                firstname: "",
                lastname: "",
                salutation: "",
                user_id: "",
                department_id: "",
                password: "",
                gender: "",
                date_of_birth: "",
                marital_status: "",
                nationality: "",
                address: "",
                phone: "",
                overtime: "",
                start_date: "",
                halfpay: false,
                bandName: "",
                emergencycontactname: "",
                emergencycontactnumber: "",
                employementtype: "",
                bandid: "",
                national_id: "",
                nssf: "",
                krapin: "",
                aadhaar_id: "",
                pan_number: "",
                sharegnum: "",
                driverslicense: "",
                contract: "",
                reportingmanager: "",
              }}
              onFinish={() => onFinish(1)}
            >
              <Row gutter={20}>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="salutation"
                    label={t("Salutation")}
                    placeholder={t("Select Salutation")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Salutation is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select Salutation")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="Mr.">Mr.</Option>
                      <Option value="Dr.">Dr.</Option>
                      <Option value="Prof.">Prof.</Option>
                      <Option value="Ms.">Ms.</Option>
                      <Option value="Mrs.">Mrs.</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="initial"
                    label={t("Initial")}
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Initial is required"),
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("Initial")}
                      maxLength={5}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="firstname"
                    label={t("First Name")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("First name is required"),
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("First name")}
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="lastname"
                    label={t("Last Name")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Last name is required"),
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("Last name")}
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="user_id"
                    label={t("Email ID")}
                    rules={[
                      {
                        required: true,
                        pattern: EMAIL_REGEX,
                        message: t("Email ID is required"),
                      },
                      { validator: validateEmployeeId },
                    ]}
                  >
                    <Input placeholder={t("Email ID")} maxLength={60} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="password"
                    label={t("Password")}
                    rules={[
                      { required: true, message: t("Password is required.") },
                      {
                        validator: (_, value) => {
                          if (!value || value.trim()?.length === 0)
                            return Promise.reject("");
                          else if (value?.length < 8 || value?.length > 15)
                            return Promise.reject(
                              t(
                                "Password should be min 8 to max 15 characters."
                              )
                            );
                          else return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder={t("Password")}
                      autoComplete="new-password"
                      maxLength={15}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="gender"
                    label={t("Gender")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Gender is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select gender")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="male">{t("Male")}</Option>
                      <Option value="female">{t("Female")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label={t("Date of Birth")}
                    name="date_of_birth"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Date of birth is required"),
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      placeholder={t("Select Date of Birth")}
                      getPopupContainer={() => containerRef.current}
                      disabledDate={(current) =>
                        current && current >= dayjs().startOf("day")
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="marital_status"
                    label={t("Marital Status")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Marital Status is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="single">{t("Single")}</Option>
                      <Option value="married">{t("Married")}</Option>
                      <Option value="widow">{t("Widow")}</Option>
                      <Option value="divorced">{t("Divorced")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="reportingmanager"
                    label={t("Reporting Manager")}
                    rules={[
                      {
                        required: userList?.length !== 0 ? true : false,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Reporting Manager is required"),
                      },
                    ]}
                  >
                    <Select
                      className="selectbox mb-2"
                      showSearch
                      placeholder={t("Select Manager")}
                      options={userList?.filter(
                        (item) => item?.statusid === "1"
                      )}
                      fieldNames={{ label: "fullname", value: "userid" }}
                      filterOption={(input, option) =>
                        (option.fullname ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      filterSort={(a, b) =>
                        (a.fullname ?? "")
                          .toLowerCase()
                          .localeCompare((b.fullname ?? "").toLowerCase())
                      }
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="nationality"
                    label={t("Country")}
                    rules={[
                      { required: true, message: t("Country is required") },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder={t("Search to Select")}
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                      onChange={handleCountryChange}
                    >
                      {countryList?.map((country, index) => (
                        <Select.Option
                          key={index}
                          value={country}
                          label={country}
                        >
                          {country}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item name="phone" label={t("Phone Number")}>
                    <PhoneInput
                      type="text"
                      defaultCountry={
                        form.getFieldValue("nationality")
                          ? getCountryCodeByName(
                              form.getFieldValue("nationality")
                            )
                          : ""
                      }
                      placeholder={t("Phone number")}
                      maxLength={
                        form.getFieldValue("nationality")
                          ? Number(
                              getMaxLengthByCountry(
                                form.getFieldValue("nationality")
                              )
                            ) + 2
                          : 15
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="emergencycontactname"
                    label={t("Emergency Contact Name")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Emergency Contact Name is required"),
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("Emergency Contact Name")}
                      maxLength={15}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="emergencycontactnumber"
                    label={t("Emergency Contact Number")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Emergency Contact Number is required"),
                      },
                    ]}
                  >
                    <PhoneInput
                      type="text"
                      defaultCountry={
                        form.getFieldValue("nationality")
                          ? getCountryCodeByName(
                              form.getFieldValue("nationality")
                            )
                          : ""
                      }
                      placeholder={t("Emergency Contact Number")}
                      maxLength={
                        form.getFieldValue("nationality")
                          ? Number(
                              getMaxLengthByCountry(
                                form.getFieldValue("nationality")
                              )
                            ) + 2
                          : 15
                      }
                    />
                  </Form.Item>
                </Col>
                {isKenyaSelected() && (
                  <>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="nssf" label={t("NSSF")}>
                        <Input
                          placeholder={t("NSSF")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) ||
                              /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/)
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="national_id" label={t("National ID")}>
                        <Input
                          placeholder={t("National ID")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) ||
                              /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/)
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="krapin"
                        label={t("kra_pin")}
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("kra_pin_required"),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("kra_pin")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/.test(e.key) ||
                              /^[a-zA-Z\s]+$/.test(e.key);
                            if (!value && e.key !== "Backspace") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="sharegnum"
                        label={t("sha_registration_number")}
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("sha_registration_number_required"),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("sha_registration_number")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/.test(e.key) ||
                              /^[a-zA-Z\s\-/._#()]+$/.test(e.key);
                            if (!value && e.key !== "Backspace") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="driverslicense"
                        label={t("drivers_license")}
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("drivers_license_required"),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("drivers_license")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/.test(e.key) ||
                              /^[a-zA-Z\s]+$/.test(e.key);
                            if (!value && e.key !== "Backspace") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="contract"
                        label={t("contract")}
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("contract_required"),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("contract")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/.test(e.key) ||
                              /^[a-zA-Z\s]+$/.test(e.key);
                            if (!value && e.key !== "Backspace") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {isIndiaSelected() && (
                  <>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="aadhaar_id" label={t("Aadhaar ID")}>
                        <Input
                          placeholder={t("Aadhaar ID")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) ||
                              /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/)
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="pan_number" label={t("PAN Number")}>
                        <Input
                          placeholder={t("PAN Number")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) ||
                              /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/)
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="address"
                    label={t("Address")}
                    rules={[
                      { required: true, message: t("Address is required") },
                    ]}
                  >
                    <Input
                      placeholder={t("Address")}
                      maxLength={60}
                      onKeyDown={(e) => {
                        const value =
                          /^[0-9,/]$/.test(e.key) ||
                          /^[a-zA-Z\s,/]+$/.test(e.key);
                        if (!value && e.key !== "Backspace") e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="overtime"
                    label={t("Overtime Eligible")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Overtime Eligible is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="yes">{t("Yes")}</Option>
                      <Option value="no">{t("No")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label={t("Start Date")}
                    name="start_date"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Start Date is required"),
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      placeholder={t("Select Start date")}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item name="salary" label={t("Salary")}>
                    <Input
                      placeholder={t("Salary")}
                      type="text"
                      maxLength={10}
                      onKeyDown={(e) => {
                        const value = /^[0-9]$/?.test(e.key);
                        if (
                          !value &&
                          e.key !== "Backspace" &&
                          e.key !== "Tab" &&
                          /^[0-9]$/
                        )
                          e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="employementtype"
                    label={t("Employment Type")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Employment Type is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="Casual">{t("Casual")}</Option>
                      <Option value="Contract">{t("Contract")}</Option>
                      <Option value="Full time">{t("Full time")}</Option>
                      <Option value="Paid Internship">
                        {t("Paid Internship")}
                      </Option>
                      <Option value="Part time">{t("Part time")}</Option>
                      <Option value="Training">{t("Training")}</Option>
                      <Option value="Unpaid Internship">
                        {t("Unpaid Internship")}
                      </Option>
                      <Option value="Probation">{t("Probation")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                {form?.getFieldValue("employementtype") === "Probation" && (
                  <>
                    <Col xs={24} sm={24} md={12} ref={containerRef}>
                      <Form.Item
                        label={t("Probation Start Date")}
                        name="probationstartdate"
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("Probation Start Date is required"),
                          },
                        ]}
                      >
                        <DatePicker
                          className="w-100"
                          format="DD-MM-YYYY"
                          placeholder={t("Select Probation start date")}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} ref={containerRef}>
                      <Form.Item
                        label={t("Probation End Date")}
                        name="probationenddate"
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("Probation End Date is required"),
                          },
                        ]}
                      >
                        <DatePicker
                          className="w-100"
                          format="DD-MM-YYYY"
                          placeholder={t("Select Probation End date")}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {form?.getFieldValue("employementtype") === "Contract" && (
                  <>
                    <Col xs={24} sm={24} md={12} ref={containerRef}>
                      <Form.Item
                        label={t("Contract Start Date")}
                        name="contractstartdate"
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("Contract Start Date is required"),
                          },
                        ]}
                      >
                        <DatePicker
                          className="w-100"
                          format="DD-MM-YYYY"
                          placeholder={t("Select Contract start date")}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} ref={containerRef}>
                      <Form.Item
                        label={t("Contract End Date")}
                        name="contractenddate"
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: t("Contract End Date is required"),
                          },
                        ]}
                      >
                        <DatePicker
                          className="w-100"
                          format="DD-MM-YYYY"
                          placeholder={t("Select Contract End date")}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Col xs={24} sm={24} md={24}>
                  <Form.Item name="profile" label={t("Profile Picture")}>
                    <StyledDropzone {...getRootProps()}>
                      <input {...getInputProps()} disabled />
                      <p>
                        {filename !== "" ? (
                          <>{filename}</>
                        ) : (
                          <>{t("choose file")}</>
                        )}
                      </p>
                    </StyledDropzone>
                  </Form.Item>
                </Col>
              </Row>
              <div className="text-end">
                <StyledButton type="primary" onClick={() => Reset()}>
                  {t("Reset")}
                </StyledButton>
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {t("Next")}
                </StyledButton>
              </div>
            </Form>
          </StyledModal>
        )}

        {step === 1 && (
          <SelectTable
            step={step}
            setStep={setStep}
            columns={baseDepartmentColumn}
            tabledata={allDepartmentList}
            editRole="edit"
            selectedBaseDepartment={baseDepartment}
          />
        )}

        {step === 2 && (
          <SelectTable
            step={step}
            setStep={setStep}
            columns={baseLocationColumn}
            tabledata={filterLocationList}
            editRole="edit"
            selectedBaseLocation={baseLocation}
          />
        )}

        {step === 3 && (
          <StyledModal>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              onFinish={() => onFinish(4)}
              autoComplete="off"
              initialValues={{
                educationdetails: [
                  {
                    institutename: "",
                    fromdate: "",
                    todate: "",
                    exambody: "",
                    awarded: "",
                    attachment: [],
                  },
                ],
                practicaltrainings: [
                  {
                    organisationname: "",
                    fromdate: "",
                    todate: "",
                    positionheld: "",
                    tasksperformed: "",
                  },
                ],
                professionalcertifications: [
                  {
                    certificationtype: "",
                    fromdate: "",
                    todate: "",
                    remarks: "",
                    attachment: [],
                  },
                ],
              }}
              labelCol={{ xs: 24, sm: 24, md: 24 }}
              style={{ textAlign: "left" }}
            >
              <b>{t("Education Details:")}</b>
              <Form.List name="educationdetails">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} key={key}>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Institute Name")}
                            name={[name, "institutename"]}
                            rules={[
                              {
                                required: true,
                                message: t("Institute Name required"),
                              },
                            ]}
                          >
                            <Input placeholder={t("Institute Name")} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("From")}
                            name={[name, "fromdate"]}
                            rules={[
                              { required: true, message: t("Date required") },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("From")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("To")}
                            name={[name, "todate"]}
                            rules={[
                              { required: true, message: t("Date required") },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("To")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label={t("Exam Body:")}
                            name={[name, "exambody"]}
                            rules={[
                              {
                                required: true,
                                message: t("Exam Body required"),
                              },
                            ]}
                          >
                            <Input placeholder={t("Exam Body")} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label={t("Awarded")}
                            name={[name, "awarded"]}
                            rules={[
                              {
                                required: true,
                                message: t("Awarded required"),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                            >
                              <Option value="Doctorate">
                                {t("Doctorate")}
                              </Option>
                              <Option value="Master">{t("Master")}</Option>
                              <Option value="Bachelor">{t("Bachelor")}</Option>
                              <Option value="Diploma">{t("Diploma")}</Option>
                              <Option value="Certificate">
                                {t("Certificate")}
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Attachment")}
                            name={[name, "attachment"]}
                            valuePropName="fileList"
                            getValueFromEvent={(e) => {
                              if (Array.isArray(e)) return e;
                              return e && e.fileList;
                            }}
                          >
                            <Upload
                              customRequest={({ file, onSuccess }) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => {
                                  const base64Data =
                                    reader.result.split(",")[1];
                                  const uniqueId = generateUniqueId();
                                  onSuccess({ file, base64Data, uniqueId });
                                };
                                reader.onerror = (error) => {
                                  console.error("File read error:", error);
                                };
                              }}
                              name="logo"
                              onChange={(value) => {
                                uploadFile(value);
                              }}
                              onRemove={(file) => {
                                handleFileRemove(file);
                              }}
                              listType="picture"
                              style={{ width: "100%" }}
                            >
                              <div style={{ width: "100%" }}>
                                <Button
                                  className="w-100 text-start"
                                  size="large"
                                >
                                  {t("Upload File")}
                                </Button>
                              </div>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        {t("+Add Another")}
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <b>{t("Practical Trainings:")}</b>
              <Form.List name="practicaltrainings">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2" key={key}>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Organisation Name")}
                            name={[name, "organisationname"]}
                          >
                            <Input placeholder={t("Organisation Name")} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("From")}
                            name={[name, "fromdate"]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("From")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("To")}
                            name={[name, "todate"]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("To")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Position Held")}
                            name={[name, "positionheld"]}
                          >
                            <Input
                              placeholder={t("Position Held")}
                              onKeyDown={(e) => {
                                const allowedChars = /^[a-zA-Z\s]+$/;
                                if (!allowedChars.test(e.key))
                                  e.preventDefault();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t(
                              "Nature of work & Tasks performed or completed"
                            )}
                            name={[name, "tasksperformed"]}
                          >
                            <Input.TextArea
                              placeholder={t(
                                "Nature of work & Tasks performed or completed"
                              )}
                            />
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        {t("+Add Another")}
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <b>{t("Professional Certifications:")}</b>
              <Form.List name="professionalcertifications">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2" key={key}>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Certification Type")}
                            name={[name, "certificationtype"]}
                          >
                            <Select
                              showSearch
                              placeholder={t("Select")}
                              optionFilterProp="children"
                              getPopupContainer={() => containerRef.current}
                              defaultValue={AwardList[0]}
                            >
                              {AwardList?.map((value, index) => (
                                <Select.Option
                                  key={index}
                                  value={value}
                                  label={value}
                                >
                                  {value}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("From")}
                            name={[name, "fromdate"]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("From")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("To")}
                            name={[name, "todate"]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("To")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Remarks")}
                            name={[name, "remarks"]}
                          >
                            <Input placeholder={t("Remarks")} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Attachment")}
                            name={[name, "attachment"]}
                            valuePropName="fileList"
                            getValueFromEvent={(e) => {
                              if (Array.isArray(e)) return e;
                              return e && e.fileList;
                            }}
                          >
                            <Upload
                              customRequest={({ file, onSuccess }) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => {
                                  const base64Data =
                                    reader.result.split(",")[1];
                                  const uniqueId = generateUniqueId();
                                  onSuccess({ file, base64Data, uniqueId });
                                };
                                reader.onerror = (error) => {
                                  console.error("File read error:", error);
                                };
                              }}
                              name="logo"
                              onChange={(value) => {
                                uploadFile(value);
                              }}
                              onRemove={(file) => {
                                handleFileRemove(file);
                              }}
                              listType="picture"
                              style={{ width: "100%" }}
                            >
                              <div style={{ width: "100%" }}>
                                <Button
                                  className="w-100 text-start"
                                  size="large"
                                >
                                  {t("Upload File")}
                                </Button>
                              </div>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        {t("+Add Another")}
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end">
                <StyledButton type="primary" onClick={() => setStep(step - 1)}>
                  {t("Back")}
                </StyledButton>
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {t("Next")}
                </StyledButton>
              </div>
            </Form>
          </StyledModal>
        )}

        {step === 4 && (
          <StyledModal>
            <Form
              form={form}
              name="addemployeeidentityform"
              layout="vertical"
              initialValues={{
                company_Name: "",
                job_Title: "",
                professional_since: "",
                hired_date: "",
                employee_sponser: "",
                employee_status: "",
                relevent: "",
                marital_status: "",
                description: "",
                workexperience: [
                  {
                    companyname: "",
                    fromdate: "",
                    todate: "",
                    jobtitle: "",
                    relevnt: "",
                    jobdescription: "",
                  },
                ],
              }}
              onFinish={() => onFinish(5)}
            >
              <Row gutter={20}>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name="company_Name"
                    label={t("Company Name")}
                    rules={[
                      {
                        required: true,
                        message: t("Company Name is required"),
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder={t("Company name")}
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="job_Title"
                    label={t("Job Title")}
                    rules={[
                      { required: true, message: t("Job Title is required") },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder={t("Job Title")}
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label={t("Last Promotion Date")}
                    name="lastpromotiondate"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Last Promotion Date is required"),
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      placeholder={t("Select Last Promotion Date")}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="lastpromotionlevel"
                    label={t("Last Promotion Level")}
                    rules={[
                      {
                        required: false,
                        message: t("Last Promotion is required"),
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder={t("Last Promotion")}
                      maxLength={100}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label={t("Professional Since")}
                    name="professional_since"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Professional Since is required"),
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      onChange={validateDateRange}
                      placeholder={t("Select start date")}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label={t("Hired Date")}
                    name="hired_date"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Hired Date is required"),
                      },
                      () => ({
                        validator(rule, value) {
                          const date = moment(value);
                          return date.isValid()
                            ? Promise.resolve()
                            : Promise.reject();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      onChange={validateDateRange}
                      placeholder={t("Select start date")}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="employee_sponser"
                    label={t("Employee Sponsor")}
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Employee Sponsor is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="yes">{t("Yes")}</Option>
                      <Option value="no">{t("No")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="employee_status"
                    label={t("Status")}
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Status is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select")}
                      getPopupContainer={() => containerRef.current}
                      onChange={(value) =>
                        setEmployeeStatusId(value === "active" ? "1" : "0")
                      }
                    >
                      <Option value="active">{t("Active")}</Option>
                      <Option value="in active">{t("In active")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="relevent"
                    label={t("Relevant")}
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: t("Relevant is required"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Select")}
                      getPopupContainer={() => containerRef.current}
                    >
                      <Option value="yes">{t("Yes")}</Option>
                      <Option value="no">{t("No")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item name="description" label={t("Description")}>
                    <Input.TextArea placeholder={t("description")} />
                  </Form.Item>
                </Col>
              </Row>
              <b>{t("Work Experience:")}</b>
              <Form.List name="workexperience">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2" key={key}>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label={t("Company name")}
                            name={[name, "companyname"]}
                          >
                            <Input placeholder={t("Company name")} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label={t("Job Title")}
                            name={[name, "jobtitle"]}
                          >
                            <Input placeholder={t("Job Title")} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("From:")}
                            name={[name, "fromdate"]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("From")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label={t("To:")}
                            name={[name, "todate"]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              placeholder={t("To")}
                              getPopupContainer={() => containerRef.current}
                              disabledDate={(current) =>
                                current && current >= dayjs().startOf("day")
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Relevant")}
                            name={[name, "relevant"]}
                          >
                            <Select
                              placeholder={t("Select")}
                              getPopupContainer={() => containerRef.current}
                            >
                              <Option value="yes">{t("Yes")}</Option>
                              <Option value="no">{t("No")}</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label={t("Job Description")}
                            name={[name, "jobdescription"]}
                          >
                            <Input.TextArea
                              placeholder={t("Job Description")}
                            />
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        {t("+Add Another")}
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end">
                <StyledButton type="primary" onClick={() => setStep(step - 1)}>
                  {t("Back")}
                </StyledButton>
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {t("Next")}
                </StyledButton>
              </div>
            </Form>
          </StyledModal>
        )}

        {step === 5 && (
          <>
            <h5>{t("Leave Management")}</h5>
            <StyledModal>
              <Form
                form={form}
                name="leaveForm"
                layout="vertical"
                initialValues={{
                  leaveAccurals: [
                    { leave_category_id: "", opening_leaves: "", accrual: "" },
                  ],
                }}
                onFinish={() => onFinish(6)}
              >
                <Form.List name="leaveAccurals">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row gutter={16} className="mt-2" key={key}>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              {...restField}
                              label={t("Leave Type")}
                              name={[name, "leave_category_id"]}
                              rules={[
                                {
                                  required:
                                    leaveCategoryList?.filter(
                                      (cat) =>
                                        cat?.accrual === "Yes" &&
                                        cat?.locationId?.includes(baseLocation)
                                    )?.length > 0
                                      ? true
                                      : false,
                                  message: t("Leave Type is required"),
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder={t("Select Leave Type")}
                                options={leaveCategoryList
                                  .filter(
                                    (cat) =>
                                      cat?.accrual === "Yes" &&
                                      cat?.locationId?.includes(baseLocation) &&
                                      !(
                                        form.getFieldValue("leaveAccurals") ||
                                        []
                                      ).some(
                                        (row, index) =>
                                          row?.leave_category_id ===
                                            cat.leave_category_id &&
                                          index !== name
                                      )
                                  )
                                  .map((it) => ({
                                    label: it.leave_category_name,
                                    value: it.leave_category_id,
                                    __raw: it,
                                  }))}
                                onChange={(value) => {
                                  const selected = leaveCategoryList.find(
                                    (it) => it.leave_category_id === value
                                  );
                                  const list =
                                    form.getFieldValue("leaveAccurals") || [];
                                  const updated = [...list];
                                  updated[name] = {
                                    ...(updated[name] || {}),
                                    leave_category_id: value,
                                    openingLeaves:
                                      selected?.openingLeaves ??
                                      updated[name]?.openingLeaves,
                                    accrual:
                                      selected?.accrual ??
                                      updated[name]?.accrual,
                                    accrualtype: selected?.accrual
                                      ? "Monthly"
                                      : undefined,
                                    number_of_leaves:
                                      selected?.number_of_leaves ??
                                      updated[name]?.number_of_leaves,
                                  };
                                  form.setFieldsValue({
                                    leaveAccurals: updated,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              {...restField}
                              label={t("Opening Leave Balance")}
                              name={[name, "openingLeaves"]}
                              rules={[
                                {
                                  required:
                                    leaveCategoryList?.filter(
                                      (cat) =>
                                        cat?.accrual === "Yes" &&
                                        cat?.locationId?.includes(baseLocation)
                                    )?.length > 0
                                      ? true
                                      : false,
                                  message: "",
                                },
                                {
                                  validator: (_, value) => {
                                    if (
                                      (value === undefined ||
                                        value === null ||
                                        value === "") &&
                                      leaveCategoryList?.filter(
                                        (cat) => cat?.accrual === "Yes"
                                      )?.length > 0
                                    ) {
                                      return Promise.reject(
                                        t("Please enter your Number of Days")
                                      );
                                    }
                                    // if (Number(value) === 0)
                                    //   return Promise.reject(
                                    //     t(
                                    //       "Please enter your Number of Days greater than zero"
                                    //     )
                                    //   );
                                    if (Number(value) >= 200)
                                      return Promise.reject(
                                        t(
                                          "Please enter your Number of Days less than 200"
                                        )
                                      );
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input
                                maxLength={4}
                                onKeyDown={(e) => {
                                  const allowedChars = /^[0-9 .]$/;
                                  if (
                                    !allowedChars.test(e.key) &&
                                    e.key !== "Backspace"
                                  )
                                    e.preventDefault();
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={6}>
                            <Form.Item
                              {...restField}
                              label={t("Accrual Applicable")}
                              name={[name, "accrual"]}
                            >
                              <Radio.Group>
                                <Radio disabled value="Yes">
                                  {t("Yes")}
                                </Radio>
                                <Radio disabled value="No">
                                  {t("No")}
                                </Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={6}>
                            <Form.Item
                              {...restField}
                              label={t("Accrual Frequency")}
                              name={[name, "accrualtype"]}
                            >
                              <Radio.Group>
                                <Radio disabled value="Monthly">
                                  {t("Monthly")}
                                </Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              {...restField}
                              label={t("Accrual Days")}
                              name={[name, "number_of_leaves"]}
                            >
                              <Input maxLength={5} disabled />
                            </Form.Item>
                          </Col>
                          {form.getFieldValue("leaveAccurals").length > 1 && (
                            <Col xs={24}>
                              <div className="w-100 mt-1 text-end">
                                <Button
                                  className="mb-2"
                                  danger
                                  onClick={() => remove(name)}
                                >
                                  {t("Remove")}
                                </Button>
                              </div>
                            </Col>
                          )}
                        </Row>
                      ))}
                      {form.getFieldValue("leaveAccurals").length <
                        leaveCategoryList?.filter(
                          (item) => item?.accrual === "Yes"
                        )?.length && (
                        <Form.Item>
                          <u
                            className="bg-transparent border-0 text-start"
                            type="dashed"
                            onClick={() => add()}
                            block
                            style={{ cursor: "pointer" }}
                          >
                            {t("+Add Another")}
                          </u>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
                <div className="text-end mt-2">
                  <StyledButton
                    type="primary"
                    onClick={() => setStep(step - 1)}
                  >
                    {t("Back")}
                  </StyledButton>
                  <StyledButton
                    loading={showLoader}
                    type="primary"
                    htmlType="submit"
                  >
                    {t("Next")}
                  </StyledButton>
                </div>
              </Form>
            </StyledModal>
          </>
        )}

        {step === 6 && (
          <RolesAndPermissions
            step={step}
            setStep={setStep}
            setMenuList={setMenuList}
            menuList={menuList}
            setsubmit={() => {}}
            paydisabled={!productInfo?.tymeplusPayStatus}
          />
        )}

        {step === 7 && (
          <InReview
            title={t("Basic Information")}
            setStep={setStep}
            step={step}
            BasicInformation={reviewBasicData}
            role={selectedRoleId}
            EducationInformation={reviewEducationData}
            baseLocation={baseLocation}
            baseDepartment={baseDepartment}
            WorkInformation={reviewWorkData}
            handleCreate={handlePermissionSubmit}
            loading={showLoader}
            leaveAccurals={form.getFieldValue("leaveAccurals") || []}
          />
        )}
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { updateUserList: setUserList, saveRoleList: setRoleList },
    dispatch
  );

const mapStateToProps = (state) => ({
  allDepartmentList: getAllDepartmentList(state),
  locationList: getLocations(state),
  ClientId: getClientid(state),
  leaveCategoryList: getLeaveCategoryList(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
  bandList: getBandList(state),
  userMenuList: getUserMenuList(state),
  clientId: getClientid(state),
  productInfo: getProductInfo(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, mapDispatchToProps, null)(AddEmployee);
